import type { FC } from 'react';
import styles from './OfflineBanner.module.css';

export const OfflineBanner: FC = () => {
  return (
    <div
      className={styles.banner}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className={styles.content}>
        <div className={styles.message}>
          <strong>Connection Lost</strong>
          <span>Unable to reach server - Check your internet connection</span>
        </div>
      </div>
    </div>
  );
};
